"use server";
import "server-only";
import { createFormAction } from "../formActions";
import Form from "../Form";

interface Props {
  actionPath: string;
}

export default async function LoginPage({
  actionPath,
}: Props) {
  if (!actionPath?.trim())
    throw new Error(
      "actionPath must not be a empty string!!"
    );
  const formAction = await createFormAction({
    pathname: actionPath,
    formType: "login",
  });
  return (
    <div>
      <Form formAction={formAction} formType="login" />
    </div>
  );
}
